import { wrap } from 'svelte-spa-router/wrap';
export const propsWrapper = (componentFile, props) => {
    return wrap({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        asyncComponent: componentFile,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        props: props,
    });
};
